(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["theme-wrap"] = factory(require("react"));
	else
		root["theme-wrap"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_63__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/